import React, { useState } from 'react';
import ReactCalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './Calendar.css';

const CalendarComponent = ({ agendamentos, onDateClick }) => {
  const [currentDate, setCurrentDate] = useState(new Date());

  const getEventsForDate = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    return agendamentos.filter(ag => {
      if (!ag.dataHora) return false;
      try {
        const agDate = new Date(ag.dataHora);
        if (isNaN(agDate.getTime())) return false;
        return agDate.toISOString().split('T')[0] === dateStr;
      } catch (e) {
        return false;
      }
    });
  };

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const events = getEventsForDate(date);
      if (events.length > 0) {
        return (
          <div className="calendar-event-indicator">
            {events.length > 3 ? (
              <span className="event-count">+{events.length}</span>
            ) : (
              events.map((event, idx) => (
                <span
                  key={event.id}
                  className={`event-dot ${event.status}`}
                  title={`${event.clienteNome} - ${event.imovelCodigo}`}
                />
              ))
            )}
          </div>
        );
      }
    }
    return null;
  };

  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const events = getEventsForDate(date);
      if (events.length > 0) {
        return 'has-events';
      }
    }
    return null;
  };

  return (
    <div className="calendar-wrapper">
      <ReactCalendar
        onChange={setCurrentDate}
        value={currentDate}
        tileContent={tileContent}
        tileClassName={tileClassName}
        onClickDay={(value) => {
          const events = getEventsForDate(value);
          if (events.length > 0 && onDateClick) {
            onDateClick(value, events);
          }
        }}
      />
      
      {/* Legenda */}
      <div className="calendar-legend">
        <div className="legend-item">
          <span className="event-dot agendado"></span>
          <span>Agendado</span>
        </div>
        <div className="legend-item">
          <span className="event-dot confirmado"></span>
          <span>Confirmado</span>
        </div>
        <div className="legend-item">
          <span className="event-dot realizado"></span>
          <span>Realizado</span>
        </div>
        <div className="legend-item">
          <span className="event-dot cancelado"></span>
          <span>Cancelado</span>
        </div>
      </div>
    </div>
  );
};

export default CalendarComponent;


